import { theme } from '@met/react-components';
import { darken } from 'polished';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${theme.colors.red};
`;

export const Title = styled.span`
  padding-left: 1rem;
  font-size: 1.5em;
`;

export const Subtitle = styled.span`
  padding-left: 1rem;
  font-size: 0.8em;
`;

export const RightActions = styled.div`
  margin-left: auto;
  display: flex;
`;

export const Action = styled.div`
  padding: 0 1rem;
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    padding: 0.3rem;
  }

  &:hover {
    color: ${darken(0.1, theme.colors.red)};
  }
`;
